import { PeriodLabel } from "src/libs/useful"
import { TimeContent } from "src/modules/pe-landing-module/data/interfaces"
import { IPrimitiveProps } from "../section/Primitive"

/* Protopia Ecosystem component */ 
const TimePrimitive = (props: IPrimitiveProps): JSX.Element => {
    const primitive: TimeContent = ( props.primitive || {} ) as TimeContent 
    return !!primitive.start_time || !!primitive.finish_time
        ?
        <TimePrimitiveContent {...props} />
        :
        <></> 
}
export default TimePrimitive


const TimePrimitiveContent = (props: IPrimitiveProps): JSX.Element => {
    const primitive: TimeContent = ( props.primitive || {} ) as TimeContent 
    return <PeriodLabel
            start_date={new Date(primitive.start_time || "").getTime()}
            finish_date={new Date(primitive.finish_time || "").getTime()}
            className={primitive.className}
            style={primitive.style}
            labelClassName={primitive.labelClassName}
            intent={primitive.intent}
            round={primitive.round}
            minimal={primitive.minimal}
        />
} 